import styles from "./ConfirmationModal.module.scss";
import Loading from "../Loading/Loading";
import Modal from "../Modal/Modal";
import React from "react";

interface Props {
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  text: string;
  heading: string;
  onConfirm: () => void;
  loading: boolean;
}

function ConfirmationModal(props: Props) {
  const { isOpen, setIsOpen, text, onConfirm, heading, loading } = props;
  return (
    <Modal isOpen={isOpen} setIsOpen={setIsOpen} showCloseIcon={false}>
      <div className={styles.mainContainer}>
        <div className={styles.headingContainer}>
          <p className={styles.label}>{heading}</p>
        </div>
        <div className={styles.modalBodyWrapper}>
          <div className={styles.textContainer}>
            <p className={styles.text}>{text}</p>
          </div>
        </div>

        <div className={styles.confirmButtonContainer}>
          {loading && <Loading />}
          <div className={styles.buttonContainer}>
            <button className={styles.button} onClick={onConfirm}>
              Confirm
            </button>
            <button
              className={styles.cancelButton}
              onClick={() => setIsOpen(false)}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </Modal>
  );
}

export default ConfirmationModal;
